export enum OrderStatus {
  VALID = 0,
  INVALID = 1,
  ALL = 2,
}

export const ORDER_CATALOG = {
  STORAGE: 1,
  TEAM: 8,
  TEAM_SHARED_STORAGE: 9,
} as const

export type OrderCatalog = (typeof ORDER_CATALOG)[keyof typeof ORDER_CATALOG]

export enum PatchOrderType {
  Invalid = 0,
  AutoRenew = 1,
  OrderToBilling = 2,
}

export const BILLING_METHODS = {
  SUBSCRIPTION: 'subscription',
  PAY_AS_YOU_GO: 'pay as you go',
} as const

export type BillingMethod = (typeof BILLING_METHODS)[keyof typeof BILLING_METHODS]

export const DURATION = {
  DAILY: 'daily',
  MONTHLY: 'monthly',
} as const

export type Duration = (typeof DURATION)[keyof typeof DURATION]

type PurchaseValue = number | 'custom'

export type PurchaseOption = {
  label: string
  value: PurchaseValue
  discount?: string
}

export const DAILY_PURCHASE_OPTIONS: PurchaseOption[] = [
  { label: '1 Day', value: 1 },
  { label: '7 Days', value: 7 },
  // { label: '15 Days', value: 15, discount: '20% Off' },//if discount, example, do not delete
  { label: '15 Days', value: 15 },
  { label: '30 Days', value: 30 },
  { label: '180 Days', value: 180 },
  { label: 'Custom', value: 'custom' },
]

export const MONTHLY_PURCHASE_OPTIONS: PurchaseOption[] = [
  { label: '1 Month', value: 30 },
  { label: '2 Months', value: 60 },
  { label: '4 Months', value: 120 },
  { label: '6 Months', value: 180 },
  { label: 'Custom', value: 'custom' },
]

export enum ItemPaymentType {
  Invalid = 0,
  Available30Days = 1,
  Available15Days = 2,
  Available7Days = 3,
  Available3Days = 4,
  Available1Days = 5,
  Available50Hours = 6,
  Available100Hours = 7,
  Available300Hours = 8,
}

export enum ItemPriceType {
  Invalid = 0,
  Original = 1,
  FirstBuy = 2,
  Renew = 3,
  UpgradeGap = 4,
  EduDiscount = 5,
}

export const INSTANCE_SUBSCRIPTION_RENEWAL = {
  status: 17,
  pricePlanType: 2,
} as const

export type InstancePlanPrice = {
  priceCent: number
  type: ItemPriceType
}

export type InstancePlanItem = {
  itemId: number
  resID: string
  catalog: number
  paymentType: ItemPaymentType
  prices: InstancePlanPrice[]
  domain: number
}

export interface Timestamp {
  seconds: number
  nanos?: number
}

export enum PaymentSource {
  SourceDefault = 0,
  SourceBonus = 1,
}

export interface ItemPrice {
  priceCent: number
  type: ItemPriceType
}

export interface OrderExtra {
  orderToBilling?: boolean
  purgeTime?: Timestamp | null
}

export interface PurchasableItem {
  id: number
  catalog: number
  paymentType: ItemPaymentType
  prices: ItemPrice[]
  desc: Record<string, any>
  sourceID: number
  qty: number
  deleted: boolean
  domain: number
  resID: string
}

export interface Order {
  id: number
  domain: number
  createTime: Timestamp
  deadlineTime: Timestamp
  autoRenewal: boolean
  item: PurchasableItem
  renewPrice: ItemPrice
  extra?: OrderExtra | null
}

export interface Pagination {
  page?: number
  per_page?: number
  total?: number
}
